import request from '@/utils/request'
// 合作渠道列表
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#4866
export function getChannelList (params) {
  return request({
    url: `/cms/channel`,
    method: 'get',
    params
  })
}
// 合作渠道不分页列表
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#4865
export function getAllChannel (params) {
  return request({
    url: `/cms/channel/find/param`,
    method: 'get',
    params
  })
}
// 超级管理员合作渠道列表
export function getSuperChannelList (params) {
  return request({
    url: `/cms/channels`,
    method: 'get',
    params
  })
}
// 合作渠道详情
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#4869
export function getChannelDetail (id) {
  return request({
    url: `/cms/channel/${id}`,
    method: 'get'
  })
}
// 合作渠道新增详情
export function getChannelDetailNew (id) {
  return request({
    url: `/cms/channeldetailed/${id}`,
    method: 'get'
  })
}
// 合作渠道删除
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#4867
export function delChannel (id) {
  return request({
    url: `/cms/channel/${id}`,
    method: 'delete'
  })
}
// 合作渠道批量删除
export function delAllChannel (params) {
  return request({
    url: `/cms/channel/bacth/del`,
    method: 'delete',
    data: params
  })
}
// 合作渠道添加
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#4864
export function addChannel (data) {
  return request({
    url: `/cms/channel`,
    method: 'post',
    data
  })
}
// 合作渠道修改
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#4868
export function updateChannel (id, data) {
  return request({
    url: `/cms/channel/${id}`,
    method: 'put',
    data
  })
}
// 合作渠道修改2
export function updateChannelNew (id, data) {
  return request({
    url: `/cms/channeldetailed/${id}`,
    method: 'put',
    data
  })
}
// 统计
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#5017
export function statisticsChannel (params) {
  return request({
    url: `/cms/channel/statistics`,
    method: 'get',
    params
  })
}
// 统计详情
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#5018
export function statisticsChannelDetail (params) {
  return request({
    url: `/cms/channel/statistics/details`,
    method: 'get',
    params
  })
}
// 报名信息统计
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=108#5038
export function getChannelEnrollInfo (params) {
  return request({
    url: `/cms/promotion/enrolment`,
    method: 'get',
    params
  })
}
// 专业列表
export function allMajor (params) {
  return request({
    url: `/lms/selfexams/major`,
    method: 'get',
    params
  })
}
// 获取专业二维码
export function majorQR (params) {
  return request({
    url: `/cms/channel/generateCode`,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/channel.js